export enum PageTitle {
  FACEBOOK = 'WordStream | Facebook Ads Performance Grader',
  GOOGLE = 'WordStream | Google Ads Performance Grader',
  KEYWORDS = 'WordStream | Free Keyword Tool',
  DISPLAY = 'WordStream | Google Ads Performance Grader | Display Report',
  SHOPPING = 'WordStream | Google Ads Performance Grader | Shopping Report',
}
